//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { DateFramedMessageModel } from './DateFramedMessageModel';
  
  export class MessagesModel extends ModelBase {
      static readonly $typeName = 'MessagesModel';
      public key: string;
      public activeBroadcastMessage: DateFramedMessageModel;
      public activeDisclaimerDescription: string;
      public draftBroadcastMessage: DateFramedMessageModel;
      public draftDisclaimerDescription: string;
      public activeNotifications: DateFramedMessageModel[];
      public historyNotifications: DateFramedMessageModel[];
      
  }



// WEBPACK FOOTER //
// ./src/app/messages/models/MessagesModel.ts